import axios from "./axios";
import {isMacSsoNoIos} from 'Utils/device';
import { isSafari } from 'Utils/browser-info';

let service = axios();
// get 请求
export default function httpGet({ url, config = {} }) {
  // 处理 mac下接口加随机数
  if(isMacSsoNoIos || isSafari) {
    let num = new Date().getTime();
    let addUrl = url.includes('?') ? `&v=${num}` : `?v=${num}`;
    url += addUrl
  }
  return new Promise((resolve, reject) => {
    service
      .get(url, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
